export default __webpack_public_path__ + "3e4e3448e02a761ec630cca59bddc02e.png";